@use "mixins" as *;
@use "variables" as *;

.product-client {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  font-weight: 300;
  //padding: 64px 0 0;
  margin: 0 auto;
  color: $grey-text;

  @include tablet {
    max-width: 1190px;
    margin-top: 2.25rem;
    padding: 0 1rem;
  }

  div {
    box-sizing: content-box;
  }
}
